(function () {
    function initWrapper(wrapper) {
      if (!wrapper) return;
      var skeletonContainer = wrapper.querySelector('.wt-skeleton-container');
      var skeletons = wrapper.querySelectorAll('.wt-skeleton');
      var widget = wrapper.querySelector('.ps-widget');
  
      function hideSkeletonIfReady() {
        if (!widget) return;
        if (widget.children && widget.children.length > 0) {
          if (skeletonContainer) {
            skeletonContainer.style.display = 'none';
          }
          if (skeletons && skeletons.length) {
            skeletons.forEach(function (el) {
              el.style.display = 'none';
            });
          }
        }
      }
  
      hideSkeletonIfReady();
  
      if (widget) {
        try {
          var mo = new MutationObserver(hideSkeletonIfReady);
          mo.observe(widget, { childList: true, subtree: true });
        } catch (e) {}
      }
  
      window.addEventListener('load', hideSkeletonIfReady);
      setTimeout(hideSkeletonIfReady, 5000);
    }
  
    function initAll() {
      var wrappers = document.querySelectorAll('.wt-product__add-to-cart_form--wrapper');
      wrappers.forEach(initWrapper);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
